import { render, staticRenderFns } from "./bubble_maps_chart.vue?vue&type=template&id=21554018&scoped=true"
import script from "./bubble_maps_chart.vue?vue&type=script&lang=js"
export * from "./bubble_maps_chart.vue?vue&type=script&lang=js"
import style0 from "./bubble_maps_chart.vue?vue&type=style&index=0&id=21554018&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21554018",
  null
  
)

export default component.exports